import ErrorLayer from './ErrorLayer';

export default ErrorLayer;


// WEBPACK FOOTER //
// ./src/components/ErrorLayer/index.js